import InquiryFlowApp from '../inquiry_flow/components/InquiryFlowApp.vue';
import { mountVueWithProps } from '../common/utils/vue';

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll<HTMLElement>('.inquiry-flow-app');
  elements.forEach((el) => {
    mountVueWithProps({ element: el, component: InquiryFlowApp });
  });
});
